import React, { useState, useEffect, useRef } from "react";
import FaceDetector from "./FaceDetector";
import WarningDialog from "./WarningDialog";

const FaceDetectionWrapper = ({
  videoStream,
  dataChannel,
  viewerId,
  onMaxWarnings,
}) => {
  const [isWarningOpen, setIsWarningOpen] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");
  const [warningCount, setWarningCount] = useState(0);
  const metricsHandlerRef = useRef(null);
  const warningTimeoutRef = useRef(null);

  // Set up an interval to check the warning dialog state
  useEffect(() => {
    const checkWarningState = () => {
      if (metricsHandlerRef.current) {
        const handler = metricsHandlerRef.current;
        if (handler.isWarningDialogOpen) {
          console.log("[FaceDetectionWrapper] Warning dialog should open", {
            message: handler.currentWarningMessage,
            count: handler.warningCount,
          });

          // Clear any existing warning timeout
          if (warningTimeoutRef.current) {
            clearTimeout(warningTimeoutRef.current);
          }

          setIsWarningOpen(true);
          setWarningMessage(handler.currentWarningMessage);
          setWarningCount(handler.warningCount);
          handler.isWarningDialogOpen = false; // Reset the flag

          // Track the violation in both systems
          // 1. Track in the current recording chunk for S3
          if (typeof window.trackViolation === "function") {
            window.trackViolation("behavior_alert", {
              type: "suspicious_behavior",
              details: {
                message: handler.currentWarningMessage,
                count: handler.warningCount,
                maxWarnings: handler.MAX_WARNINGS,
                timestamp: new Date().toISOString(),
              },
            });
          } else {
            console.log(
              "[FaceDetectionWrapper] trackViolation function not available"
            );
          }

          // 2. Track in localStorage for warning system
          try {
            const cache = JSON.parse(
              localStorage.getItem("suspiciousActions")
            ) || {
              eyes_closed: [],
              looking_away: [],
              speaking: [],
            };

            // Add the violation to all categories since this is a general warning
            const now = Date.now();
            cache.eyes_closed.push(now);
            cache.looking_away.push(now);
            cache.speaking.push(now);

            localStorage.setItem("suspiciousActions", JSON.stringify(cache));
          } catch (error) {
            console.error(
              "[FaceDetectionWrapper] Error updating localStorage:",
              error
            );
          }

          // Auto-close warning after 10 seconds
          warningTimeoutRef.current = setTimeout(() => {
            setIsWarningOpen(false);
          }, 10000);

          // Check if max warnings reached
          if (handler.warningCount >= handler.MAX_WARNINGS) {
            console.log(
              "[FaceDetectionWrapper] Max warnings reached, will stop in 2s"
            );
            setTimeout(() => {
              console.log("[FaceDetectionWrapper] Calling onMaxWarnings");
              onMaxWarnings();
            }, 2000);
          }
        }
      }
    };

    const interval = setInterval(checkWarningState, 500);

    return () => {
      clearInterval(interval);
      if (warningTimeoutRef.current) {
        clearTimeout(warningTimeoutRef.current);
      }
    };
  }, [onMaxWarnings]);

  const handleCloseWarning = () => {
    console.log("[FaceDetectionWrapper] Closing warning dialog");
    if (warningTimeoutRef.current) {
      clearTimeout(warningTimeoutRef.current);
    }
    setIsWarningOpen(false);
  };

  console.log("[FaceDetectionWrapper] Render", {
    isWarningOpen,
    warningMessage,
    warningCount,
  });

  return (
    <>
      <FaceDetector
        videoStream={videoStream}
        dataChannel={dataChannel}
        viewerId={viewerId}
        metricsHandlerRef={metricsHandlerRef}
      />
      <WarningDialog
        isOpen={isWarningOpen}
        onClose={handleCloseWarning}
        message={warningMessage}
        warningCount={warningCount}
      />
    </>
  );
};

export default FaceDetectionWrapper;
